import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './langs/en'
import ru from './langs/ru.json'
import am from './langs/am.json'

const getCurrentLang = (): string => {
	const lang = localStorage.getItem('lang')
	return lang ? lang : 'en'
}

const translations = {
	en: { translation: en },
	ru: { translation: ru },
	am: { translation: am },
}

i18n.use(initReactI18next).init({
	fallbackLng: 'en',
	lng: getCurrentLang(),
	interpolation: {
		escapeValue: false,
	},
	resources: translations,
})

export default i18n
